import { isLocalUrl } from './routes.js';

export const tryUrlFromString = (url: string) => {
  try {
    return new URL(url);
  } catch {
    return null;
  }
};

export const appendQueryParams = (
  urlString: string,
  params: Record<string, string>
) => {
  const url = new URL(urlString);

  Object.entries(params).forEach(([k, v]) => {
    url.searchParams.set(k, v);
  });

  return url.toString();
};

export const addUtmParamsToExternalLink = (
  link?: string,
  params?: Record<string, string>
) => {
  if (!link || !params || isLocalUrl(link)) {
    return link;
  }

  const url = new URL(link);
  Object.entries(params).forEach(([key, value]) => {
    if (value) {
      url.searchParams.set(
        key,
        // if the link contains this param, we don't want to overwrite it
        url.searchParams.get(key) || value
      );
    }
  });
  return url.toString();
};
